'use client'

import React from 'react'
import dynamic from 'next/dynamic'

const Inscribe = dynamic(() => import('@/app/inscribe/inscribe/index'), { ssr: false })

export default function InscribeClientComponent({ searchParams }: any) {
  return <Inscribe searchParams={searchParams} />
}
